import React from 'react';
import { useApp } from '../context/AppContext';

// "Put this on your phone."
//
// Two very different jobs behind one card: on Android Chrome hands us a real
// install prompt, so this is a button. On iPhone there is no API whatsoever —
// the only path is Share → Add to Home Screen — so this is instructions.
// It renders nothing at all once the app is installed, or when there is
// nothing useful to offer, so it can be dropped onto any screen safely.
export default function InstallCard() {
  const { canInstall, handleInstall, installHint, isInstalled } = useApp();

  if (isInstalled()) return null;
  const hint = installHint();
  if (!canInstall && !hint) return null;

  return (
    <div style={{
      border: '1px solid var(--border)', borderRadius: 12,
      padding: 14, marginBottom: 14, background: 'var(--white)',
    }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, marginBottom: 6 }}>
        Add to your phone
      </div>
      <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.55, marginBottom: canInstall ? 10 : 0 }}>
        {canInstall
          ? 'Install it for an icon on your home screen, a full screen without the browser bar, and job details that still open when you have no signal.'
          : hint}
      </div>
      {canInstall && (
        <button className="btn btn-primary btn-sm" onClick={handleInstall}>Install app</button>
      )}
    </div>
  );
}
